<div id="header">
  <div class="non-title-container">
    <button
      id="header-menu-button"
      type="button"
      aria-label="Open menu"
      (click)="sideNavigatorService.toggleSideNavigator()"
    >
      <mat-icon>menu</mat-icon>
    </button>
  </div>
  <div id="title-container">
    <!-- Press and hold the title to show viewport diagnostics -->
    <span
      class="header-title"
      (touchstart)="startDiagnosticsPress()"
      (touchend)="cancelDiagnosticsPress()"
      (touchcancel)="cancelDiagnosticsPress()"
      (mousedown)="startDiagnosticsPress()"
      (mouseup)="cancelDiagnosticsPress()"
      (mouseleave)="cancelDiagnosticsPress()"
      >{{ displayTitle }}</span
    >
  </div>
  <div class="right-container">
    <div id="header-org-badge-frame" *ngIf="organizationLogoUrl">
      <img
        id="header-org-badge"
        [src]="organizationLogoUrl | safeUrl"
        alt="Organization"
        (error)="onBadgeImageError()"
      />
    </div>
  </div>
</div>

<div id="viewport-diagnostics" *ngIf="diagnostics" (click)="diagnostics = null">
  <div class="diagnostics-title">Viewport diagnostics (tap to close)</div>
  <pre>{{ diagnostics }}</pre>
</div>
